export default __webpack_public_path__ + "static/media/65_photo.33bae481.jpg";